import React, { type ReactFragment } from 'react'
import { Grid, Typography } from '@mui/material'
import CurrencyCodeChip from '../../../views/components/chips/CurrencyCodeChip'
import { DataGrid } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { type LedgerMutationsByCurrencySummary } from '../../../api-schema-types/assets/AssetProjectCrudDtos'
import { type EditSolarProjectComponentProps } from './EditSolarProjectForm'
import { type GridColDef } from '@mui/x-data-grid'

const EditCrowdSalePanel: React.FC<EditSolarProjectComponentProps> = ({
  project,
  overrideLockedFields,
  triggerRefetch
}: EditSolarProjectComponentProps) => {
  /* const dispatch = useAppDispatch()

  const formikProps: FormikContextType<AssetProjectUpdateDto> = useFormikContext()

  const isFieldLocked = (): boolean => {
    return true
  } */
  const currencySummaryColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 50, editable: false },
    {
      field: 'currency',
      headerName: 'Currency',
      width: 120,
      renderCell: params => <CurrencyCodeChip code={params.row.currencyCode} name={`[${params.row.currencyId}] ${params.row.currency}`}/>
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 200,
      editable: false
    },
    {
      field: 'srcCurrency',
      headerName: 'Source currency',
      width: 120,
      renderCell: params => <CurrencyCodeChip code={params.row.srcCurrencyCode} name={`[${params.row.srcCurrencyId}] ${params.row.srcCurrency}`}/>
    },
    {
      field: 'srcAmount',
      headerName: 'Source amount',
      width: 200,
      editable: false
    }
  ]

  const renderCurrencySummaryDataGrid = (): ReactFragment => {
    let summaries: LedgerMutationsByCurrencySummary[] = []
    if (project.crowdSale.ordersSummaries != null) {
      summaries = project.crowdSale.ordersSummaries
    }
    return <DataGrid
      rows={summaries}
      columns={currencySummaryColumns}
      autoHeight={true}
      pageSize={5}
      rowsPerPageOptions={[5]}
      disableSelectionOnClick
    />
  }

  const calculateDifference = (expectedValue: number | null, actualValue: number | null): number => {
    if ((expectedValue != null) && (actualValue != null)) {
      return expectedValue - actualValue
    }
    return 0
  }

  return (
    <>
      <Grid container spacing={4}>
         <Grid item md={12} sx={{ mt: 3 }}></Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Project cells</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.countProjectCells}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Amount expected</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.totalSrcAmountExpected}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Cell owners</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.countCellOwners}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Cell owner agreements</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.countCurrentCellOwnerAgreements}</strong>
          </Typography>
        </Grid>
      </Grid>
      {/* ==================================================================================================== */}
      <Grid container spacing={4}>
        <Grid item md={2}>
          <Typography variant={'body2'}>Cells in orders</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.countCellsInOrders}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Amount accumulated</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.totalSrcAmountAccumulated}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}># Orders</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.countOrders}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Free cells</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{project.crowdSale.totalFreeCells}</strong>
          </Typography>
        </Grid>
      </Grid>
      {/* ==================================================================================================== */}
      <Grid container spacing={4}>
        <Grid item md={2}>
          <Typography variant={'body2'}>Diff: cell numbers</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{calculateDifference(project.crowdSale.countProjectCells, project.crowdSale.countCellsInOrders)}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
          <Typography variant={'body2'}>Diff: amounts</Typography>
          <Typography variant={'subtitle1'}>
            <strong>{calculateDifference(project.crowdSale.totalSrcAmountExpected, project.crowdSale.totalSrcAmountAccumulated)}</strong>
          </Typography>
        </Grid>
        <Grid item md={2}>
        </Grid>
        <Grid item md={2}>
        </Grid>
      </Grid>
      {/* ==================================================================================================== */}
      <Paper>
        <Box sx={{ p: 4, mt: 3 }}>
          { renderCurrencySummaryDataGrid()}
        </Box>
      </Paper>
    </>
  )
}

export default EditCrowdSalePanel
